import { NAV_LINK_1, NAV_LINK_2, NAV_LINK_3 } from '../../../../constants';
import { motion } from 'framer-motion';
import Link from 'next/link';

interface INavBar {
  onMenuToggle?: () => void;
}

export function NavbarMobile({ onMenuToggle }: INavBar) {
  return (
    <motion.nav
      initial={{
        x: -500,
      }}
      animate={{
        x: 0,
      }}
    >
      <nav>
        <ul>
          <h3 style={{marginTop: "10px"}}>Основное</h3>
          {
            NAV_LINK_1.map((link, index) => {
              return (
                <li key={"LINK_1_link_" + index}><a href={link.url}>{link.title}</a></li>
              )
            })
          }
        </ul>
        <ul>
          <h3 style={{marginTop: "20px"}}>Компания</h3>
          {
            NAV_LINK_2.map((link, index) => {
              return (
                <li key={"LINK_1_link_" + index}><a href={link.url}>{link.title}</a></li>
              )
            })
          }
        </ul>
        {/*<ul>*/}
        {/*  <h3 style={{ marginTop: 20 }}></h3>*/}
        {/*  {NAV_LINK_3.map((link, index) => {*/}
        {/*    return (*/}
        {/*      <li key={'LINK_1_link_' + index}>*/}
        {/*        <a href={link.url}>{link.title}</a>*/}
        {/*      </li>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</ul>*/}
        <ul
          style={{
            marginTop: 24,
          }}
        >
          <li>
            <Link href={'https://xn--80acmlhv0b.xn----7sbbcf5aipa3c3b.xn--p1ai/'}>
              Личный кабинет
            </Link>
          </li>
        </ul>
      </nav>
    </motion.nav>
  );
}
